import { AuthConfig } from 'angular-oauth2-oidc';
import { AppUrls } from '../app-urls';
import { AppConfig } from '../../appconfig';

export class AuthConfigHelper {
  constructor(private appConfig: AppConfig) {}

  authConfig(): AuthConfig {
    const cfg = new AuthConfig();

    if (this.appConfig.externalIdentity()) {
      cfg.strictDiscoveryDocumentValidation = false;
      cfg.issuer = this.appConfig.extIdentityUri();
      cfg.clientId = this.appConfig.extIdentityClientId();
      cfg.scope = this.appConfig.extIdentityScopes();

    } else {
      cfg.loginUrl = AppUrls.getAuthUrl(AppUrls.actionAuthLogin);
      cfg.logoutUrl = AppUrls.getAuthUrl(AppUrls.actionAuthLogout);

      cfg.tokenEndpoint = AppUrls.getAuthUrl(AppUrls.actionAuthToken);
      cfg.userinfoEndpoint = AppUrls.getAuthUrl(AppUrls.actionAuthUserInfo);
      cfg.revocationEndpoint = AppUrls.getConnectUrl(AppUrls.actionConnectRevocation);
      cfg.issuer = AppUrls.baseUrlMvc;
      cfg.clientId = 'roesberg.angular'; // The "Auth Code + PKCE" client

      // if you like to use angular on a unencrypted http site (intranet)
      cfg.requireHttps = !this.appConfig.disableSSL();
      cfg.jwks = this.appConfig.jwks();
      cfg.useSilentRefresh = true;
      cfg.silentRefreshRedirectUri = AppUrls.baseUrlAngular + AppUrls.actionSilentRefresh;
    }

    cfg.responseType = 'code';
    cfg.redirectUri = AppUrls.baseUrlAngular;

    // for testing purpose with silent refresh of tokens
    // cfg.silentRefreshTimeout = 5000;
    // cfg.timeoutFactor = 0.1;

    // If Angular shall handle sessions (multi system login for same user),
    // we could use this session system. But Ldw uses serverside internal
    // session management, so there is no need/sense for this
    // cfg.sessionCheckIFrameUrl = AppUrls.getAuthUrl(AppUrls.actionAuthSessionCheck);
    // cfg.sessionChecksEnabled = true;

    cfg.showDebugInformation = true; // Also requires enabling "Verbose" level in devtools
    cfg.clearHashAfterLogin = false; // https =//github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040;
    cfg.nonceStateSeparator = 'semicolon'; // Real semicolon gets mangled by IdentityServer's URI encoding

    return cfg;
  }
}
